import { __rest } from 'tslib';
import 'react';
import '../../analytics/context.js';
import { authErrorEvent, calculatorOnParamErrorEvent, calculatorOnParamChangeEvent, buttonsClickEvent, calculatorGoToFormEvent, calculatorOnMountEvent } from '../../analytics/events.js';
import { EVENT_TYPE } from './constants.js';

var getFormValuesLabelString = function (values) {
    return [values.amount, values.period.label, values.purpose.label, values.rate].join('|');
};
var defaultCalculatorEventHandler = function (eventEmitter) { return function (event) {
    switch (event.type) {
        case EVENT_TYPE.CALCULATOR_MOUNT: {
            var _a = event.payload, page = _a.page, values = __rest(_a, ["page"]);
            eventEmitter(calculatorOnMountEvent([page, getFormValuesLabelString(values)].join('|')));
            break;
        }
        case EVENT_TYPE.CALCULATOR_REDIRECT_TO_FORM: {
            var _b = event.payload, label = _b.label, page = _b.page, values = __rest(_b, ["label", "page"]);
            eventEmitter(calculatorGoToFormEvent([label, page, getFormValuesLabelString(values)].join('|')));
            break;
        }
        case EVENT_TYPE.CALCULATOR_BUTTON_CLICK: {
            var _c = event.payload, label = _c.label, page = _c.page;
            eventEmitter(buttonsClickEvent([label, page].join('|')));
            break;
        }
        case EVENT_TYPE.CALCULATOR_PARAM_CHANGED: {
            var _d = event.payload, page = _d.page, fieldLabel = _d.fieldLabel;
            eventEmitter(calculatorOnParamChangeEvent([fieldLabel, page].join('|')));
            break;
        }
        case EVENT_TYPE.CALCULATOR_PARAM_ERROR: {
            var fieldLabel = event.payload.fieldLabel;
            eventEmitter(calculatorOnParamErrorEvent([fieldLabel, 'Ошибка валидации', 'Обязательное'].join('|')));
            break;
        }
        case EVENT_TYPE.CALCULATOR_AUTH_ERROR: {
            var _e = event.payload, label = _e.label, page = _e.page;
            eventEmitter(authErrorEvent([label, page].join('|')));
            break;
        }
    }
}; };

export { defaultCalculatorEventHandler };
//# sourceMappingURL=event.handler.js.map
